export default __webpack_public_path__ + "static/media/netflix.774e8c16.png";